var map = {
	"./animal.svg": 535,
	"./arrow.svg": 536,
	"./bicycle.svg": 537,
	"./boat.svg": 538,
	"./bus.svg": 539,
	"./car.svg": 540,
	"./crane.svg": 541,
	"./default.svg": 542,
	"./helicopter.svg": 543,
	"./motorcycle.svg": 544,
	"./offroad.svg": 545,
	"./person.svg": 366,
	"./pickup.svg": 546,
	"./plane.svg": 547,
	"./ship.svg": 548,
	"./tractor.svg": 367,
	"./train.svg": 549,
	"./tram.svg": 550,
	"./trolleybus.svg": 551,
	"./truck.svg": 552,
	"./van.svg": 553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;